export default "__VITE_ASSET__4f592731__"